module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.fa2772327f55d8198301.woff";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/theme/fonts/glyphicons-halflings-regular.woff
// module id = 866
// module chunks = 2